import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-jalaali';

/**
 * For Change gregorian to jalali.
 */
@Pipe({
  name: 'jalaliDate'
})
export class JalaliDatePipe implements PipeTransform {

  transform(date: string, param?: any): any {
    let format;

    if (!date) {
      return '-';
    }
    if (date === 'اکنون') {
      return date;
    }

    if (param === 'timeDiff24') {
      const then = date;
      const ms = moment().diff(moment(then, 'YYYY - MM - DDTHH: mm: ss'));
      const d = moment.duration(ms);
      const hour24 = (24 * 3600000) - d.asMilliseconds(); //  24h to ms - my ms
      return moment.utc(hour24).format('H:mm');
    }

    switch (param) {
      case 'yearMonth':
        format = 'jMMMM jYYYY';
        break;
      case 'dayMonth':
        format = 'jDD jMMMM';
        break;
      case 'dayPersianMonthYear':
        format = 'jDD jMMMM jYYYY';
        break;
      case 'dateTime':
        format = 'HH:mm' + ' ، ' + 'jDD jMMMM  jYYYY';
        break;
      default:
        format = 'jYYYY/jMM/jDD';
    }
    return moment(date).locale('fa').format(format);
  }
}
